import { arrayToConstMap } from './utils';
import { CandidatesConst } from './candidate';

const { ProfileStatuses } = CandidatesConst;

const BlockingConditions = [
  'oppDoesNotExist',
  'oppClosed',
  'noPositions',
  'notAllPositionsAreAcceptablyTyped',
  'positionDescriptionsAllEmpty',
] as const;

const BlockingConditionsMap = arrayToConstMap(BlockingConditions);

if (Object.keys(BlockingConditionsMap).includes('undefined')) {
  throw new Error(
    `A key in BlockingConditionsMap is undefined in ml recommendations const (aka developer do bad-bad) ${Object.keys(
      BlockingConditionsMap
    ).join(',')}`
  );
}

export const MLRecommendationsConst = {
  BlockingConditions,
  BlockingConditionsMap,

  DefaultProfileStatuses: [
    ProfileStatuses.Active,
    ProfileStatuses.Beach,
    ProfileStatuses.PendingActive,
    ProfileStatuses.PendingBeach,
    ProfileStatuses.Waitlist,
  ],
} as const;
